<script setup>
import { Cog6ToothIcon, TrashIcon } from "@heroicons/vue/20/solid";
import BaseBlock from "./BaseBlock.vue";
import { getBlock } from "@Utils/project";
import { computed } from "vue";
import Tooltip from "@Components/Tooltip.vue";
import { useI18n } from "vue-i18n";

const model = defineModel();

defineEmits(["deleteBlock", "configureBlock"]);

const { t: __ } = useI18n();

const block = computed(() => {
    return getBlock(model.value.block);
});

const name = computed(() => {
    if (typeof block.value.name === "function") {
        return block.value.name(model.value);
    }

    return block.value.name;
});
</script>

<template>
    <BaseBlock>
        <div class="flex items-center space-x-3">
            <div class="flex-none">
                <component v-if="block.icon" :is="block.icon" class="w-4 h-4 text-gray-400 dark:text-gray-400" />
                <div v-else class="w-4 h-4 flex justify-center items-center text-gray-900 uppercase dark:text-white">{{ block.key[0] + block.key[1] }}</div>
            </div>
            <div class="flex-1">{{ name }}</div>
            <div class="flex flex-none items-center space-x-1.5">
                <Tooltip v-if="block.is_customizable" :content="__('Configurer')">
                    <Cog6ToothIcon
                        @click="$emit('configureBlock')"
                        class="w-4 h-4 text-gray-400 cursor-pointer dark:text-gray-400 dark:hover:text-white hover:text-gray-600" />
                </Tooltip>
                <Tooltip :content="__('Supprimer')">
                    <TrashIcon
                        @click="$emit('deleteBlock')"
                        class="w-4 h-4 text-gray-400 cursor-pointer dark:text-gray-400 dark:hover:text-white hover:text-gray-600" />
                </Tooltip>
            </div>
        </div>
    </BaseBlock>
</template>
